import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Input, Text } from '@modusign/design-system';

interface PermissionAssigneeSearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

export default function PermissionAssigneeSearchInput({
  placeholder = '이름 또는 이메일로 검색',
  value,
  onChange,
}: PermissionAssigneeSearchInputProps) {
  return (
    <Box position="relative">
      <Text
        as={FontAwesomeIcon}
        color="textNeutralVeryLight"
        icon={faSearch as IconProp}
        style={{
          position: 'absolute',
          top: '50%',
          left: 10,
          transform: 'translate(0,-50%)',
        }}
      />
      <Input
        placeholder={placeholder}
        sx={{
          px: '30px',
        }}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {value && (
        <Box
          as="button"
          p={3}
          style={{
            position: 'absolute',
            top: '50%',
            right: 2,
            transform: 'translate(0,-50%)',
          }}
          onClick={() => onChange('')}
        >
          <Text as={FontAwesomeIcon} color="textNeutralVeryLight" icon={faXmark as IconProp} />
        </Box>
      )}
    </Box>
  );
}
